import { capitalize } from 'lodash';

export function formatSource(source: string) {
    source = source.trim().replace(/\s{2,}/g, ' ');

    switch (true) {
        case /^nvd$/i.test(source):
            return 'NVD';
        case /^cna$/i.test(source):
            return 'CNA';
        default:
            return capitalize(source);
    }
}
